import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Zone } from '../interfaces/zones';

async function getZones(): Promise<Zone[]> {
	try {
		const response = await axios.get<Envelope<Zone[]>>(`lighting/zones`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const zones = {
	getZones,
};
